import { render, staticRenderFns } from "./TroskovnikReportEdit.vue?vue&type=template&id=279e54e2"
import script from "./TroskovnikReportEdit.vue?vue&type=script&lang=js"
export * from "./TroskovnikReportEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports